import './components/header'
import './components/logout'
import './components/notification'
import './components/global_search'

import { initAgencyRegistrationForm } from './pages/agency_management/agency_registration_form'
import { initApiOptions } from './pages/agency/api_options'
import { initApplicantCreate } from './pages/applicant/applicant_create'
import { initApplicantDetail } from './pages/applicant/applicant_detail'
import { initApplicantList } from './pages/applicant/applicant_list'
import { initApplicantUpdate } from './pages/applicant/applicant_update'
import { initApplicationDetail } from './pages/application/application_detail'
import { initApplicationList } from './pages/application/application_list'
import { initBranchAccreditation } from './pages/agency/branch_accreditation'
import { initCommissionsList } from './pages/commissions/commissions_list'
import { initDashboard } from './pages/dashboard/dashboard'
import { initFormList } from './pages/forms/form_list'
import { initInboxCompose } from './pages/inbox/inbox_compose'
import { initInboxList } from './pages/inbox/inbox_list'
import { initProviderList } from './pages/provider/provider_list'
import { initResourceList } from './pages/provider/resource_list'
import { initDisableOnSubmitButtons } from './components/button'
import { initTakeMeBack } from './components/take_me_back'
import { initAgencyLeadEdit } from './pages/studylink_support/agency_lead_edit'
import { initAgencyCreate } from './pages/studylink_support/create_agency'
import { initBranchList } from './pages/studylink_support/branch_list'
import { initAccreditation } from './components/studylink_support/accreditation'
import { initBranchUpdate } from './pages/agency/branch_update'
import { initPreApplicationForm } from './pages/applicant/pre_application_form'
import { initAutoShowingModals } from './components/auto_modal'
import { initMfa, initMfaLoginSetup } from './components/mfa'
import { initOtpInputs } from './components/otp_input'

// The body tag is given a namespace for each page in the form of a CSS class.
// We can check that class here to initialise page scripts only when needed.
// Any heavy scripts that are not needed on every page (e.g. anything schema form related)
// should be imported lazily; see the Parcel docs for more info: https://parceljs.org/features/code-splitting/

const classes = document.querySelector('body')?.classList || new DOMTokenList()

if (classes.contains('hyper-agency-register')) {
  initAgencyRegistrationForm()
}

if (classes.contains('hyper-applicant-list')) {
  initApplicantList()
}

if (classes.contains('hyper-applicant-detail')) {
  initApplicantDetail()
}

if (classes.contains('hyper-applicant-create')) {
  initApplicantCreate()
}

if (classes.contains('hyper-applicant-update')) {
  initApplicantUpdate()
}

if (classes.contains('hyper-application-list')) {
  initApplicationList()
}

if (classes.contains('hyper-application-detail')) {
  initApplicationDetail()
}

if (classes.contains('hyper-commissions-list')) {
  initCommissionsList()
}

if (classes.contains('hyper-inbox-list')) {
  initInboxList()
}

if (classes.contains('hyper-inbox-compose')) {
  initInboxCompose()
}

if (classes.contains('hyper-form-preview')) {
  import('./pages/forms/form_preview')
}

if (classes.contains('hyper-form-list')) {
  initFormList()
}

if (classes.contains('hyper-api-options')) {
  initApiOptions()
}

if (classes.contains('hyper-resource-detail')) {
  initResourceList()
}

if (classes.contains('hyper-provider-list')) {
  initProviderList()
}

if (classes.contains('hyper-branch-accreditation-create')) {
  initBranchAccreditation()
}

if (classes.contains('hyper-branch-accreditation-update')) {
  initBranchAccreditation()
}

if (classes.contains('sl-support-agency-lead-edit')) {
  initAgencyLeadEdit()
}

if (classes.contains('sl-support-branch-list')) {
  initBranchList()
}

if (classes.contains('sl-support-agency-create')) {
  initAgencyCreate()
}

if (classes.contains('sl-support-branch-accreditation-create')) {
  initAccreditation()
}

if (classes.contains('sl-support-branch-accreditation-edit')) {
  initAccreditation()
}

// Initialize MFA functionality when MFA-related elements are present
if (
  document.querySelector(
    '#mfa-setup-modal, #mfa-backup-codes-modal, #mfa-delete-verification-modal, #mfa-verify-toggle',
  )
) {
  initMfa()
}

if (classes.contains('hyper-login-mfa-setup')) {
  initMfaLoginSetup()
}

if (classes.contains('hyper-applicant-pre-application-form')) {
  initPreApplicationForm()
}

if (classes.contains('hyper-dashboard')) {
  initDashboard()
}

// There are a number of links with `href="javascript: window.history.back()"`
// in various pages. Instead of handling them on a per-page basis, we'll just initialize them
// whenever they exist.
//
// DEVELOPER NOTES: if you need to have one of these links please make sure you add
// `class="take-me-back"`, e.g.:
// <a class="take-me-back" href="javascript: window.history.back()"></a>
if (document.querySelector('.take-me-back')) {
  initTakeMeBack()
}

// Similarly, there are a number of buttons that are disabled upon form submission
// in various pages. We're not going to handle them on a per-page basis.
//
// DEVELOPER NOTES: if you need to have on of these buttons please make sure you add
// `class="disable-on-submit"`, e.g.:
// <button class="disable-on-submit" type="submit"></button>
if (document.querySelector('button.disable-on-submit')) {
  initDisableOnSubmitButtons()
}

if (classes.contains('hyper-branch-update')) {
  initBranchUpdate()
}

// initialize phone number inputs
if (document.querySelector('input.phone-number')) {
  import('./components/phone_number').then(function ({ initPhoneNumbers }) {
    initPhoneNumbers()
  })
}

// hcaptcha
if (document.querySelector('button.h-captcha')) {
  import('./components/hcaptcha')
}

// initialize searchable dropdowns
if (document.querySelector('select[data-searchable="true"]')) {
  import('./components/searchable_dropdown').then(function ({
    initSearchableDropdowns,
  }) {
    initSearchableDropdowns()
  })
}

// initialize auto modals
if (document.querySelector('[data-auto-show]')) {
  initAutoShowingModals()
}

// initialize OTP code inputs
if (document.querySelector('.otp-input-container')) {
  initOtpInputs()
}
